import React from 'react';

export default function ZaminRythu() {
  return (
    <a
      href="https://www.teluguone.com/ePaper/zaminryot/"
      target="_blank"
      rel="noreferrer"
      className="t1-zaminrythu"
    >
      <img
        src="https://www.teluguone.com/ePaper/zaminryot/img/logo.png"
        alt="Zamin Rythu ePaper"
        loading="lazy"
      />
      {/* <span>Zamin Rythu ePaper చదవండి →</span> */}
    </a>
  );
}
